var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawalMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cash-Finance-Loan-Money-Income"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49 3a3 3 0 0 1 0 6h-32a3 3 0 0 1 0-6z",
    fill: "#898890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 37h-9v-9a9 9 0 0 1 9 9z",
    fill: "#00b39d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 28v9h-9a9 9 0 0 1 9-9z",
    fill: "#00b39d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 3v25a9 9 0 0 0 -9 9h-8a9 9 0 0 0 -9-9v-25z",
    fill: "#00ccb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 53v8h-18v-8h2 14z",
    fill: "#3d9ae2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 37v-8a3 3 0 0 1 6 0v7l.4 1 .88 2.21a9.853 9.853 0 0 1 .72 3.72v1.3a9.973 9.973 0 0 1 -1.43 5.15l-1.57 2.62v1h-14v-4l-1.42-12.78a15.968 15.968 0 0 1 2.05-9.77l4.37-7.57v18.12z",
    fill: "#ffc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 21-5 6-5-6h3v-19h4v19z",
    fill: "#ffa733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 35-5 6-5-6h3v-19h4v19z",
    fill: "#ffa733"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 13,
    fill: "#ffd422",
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 3h26v2h-26z",
    fill: "#00b39d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 13a7 7 0 1 0 -7 7 7.008 7.008 0 0 0 7-7zm-12 0a5 5 0 1 1 5 5 5.006 5.006 0 0 1 -5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 2h-32a4 4 0 0 0 0 8h2v8.61l-4.24 7.34a16.835 16.835 0 0 0 -2.17 10.38l1.41 12.73v2.94h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0 -1-1h-.83l1.26-2.1a10.983 10.983 0 0 0 1.57-5.67v-1.3a10.907 10.907 0 0 0 -.79-4.09l-.34-.84h14.13a1 1 0 0 0 1-1v-27h2a4 4 0 0 0 0-8zm-28 27.07a7.674 7.674 0 0 1 2 .53v6.4h-2zm-4-21.07a2.006 2.006 0 0 1 -2-2 2.015 2.015 0 0 1 2-2h2v4zm13 52h-16v-6h16zm1-15.77a8.945 8.945 0 0 1 -1.29 4.64l-1.57 2.62a1 1 0 0 0 -.14.51h-12v-3a.41.41 0 0 0 -.01-.11l-1.42-12.78a14.908 14.908 0 0 1 1.93-9.16l2.5-4.34v14.39a1 1 0 0 0 1 1h3v1h2v-10a2.006 2.006 0 0 1 2-2 2.015 2.015 0 0 1 2 2v7a.937.937 0 0 0 .07.37l1.28 3.22a8.793 8.793 0 0 1 .65 3.34zm14-8.23h-6.93a8 8 0 0 1 6.93-6.93zm0-8.95a10.012 10.012 0 0 0 -8.95 8.95h-4.97l-.08-.19v-6.81a3.993 3.993 0 0 0 -7.72-1.44 9.884 9.884 0 0 0 -2.28-.5v-23.06h24zm5.41-19.64a1.983 1.983 0 0 1 -1.41.59h-2v-4h2a2.006 2.006 0 0 1 2 2 1.983 1.983 0 0 1 -.59 1.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.906 34.576a1 1 0 0 0 -.906-.576h-2v-18h-2v19a1 1 0 0 0 1 1h.865l-2.865 3.438-2.865-3.438h.865a1 1 0 0 0 1-1v-19h-2v18h-2a1 1 0 0 0 -.768 1.64l5 6a1 1 0 0 0 1.536 0l5-6a1 1 0 0 0 .138-1.064z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.906 20.576a1 1 0 0 0 -.906-.576h-2v-18h-2v19a1 1 0 0 0 1 1h.865l-2.865 3.438-2.865-3.438h.865a1 1 0 0 0 1-1v-19h-2v18h-2a1 1 0 0 0 -.768 1.64l5 6a1 1 0 0 0 1.536 0l5-6a1 1 0 0 0 .138-1.064z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalMoney);
export default __webpack_public_path__ + "static/media/withdrawal-money.6d0a7dd4dadec69e1ba03be353549c1d.svg";
export { ForwardRef as ReactComponent };